import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductsComponent } from '@app/features/products/products/products.component';
import { AddProductComponent } from '@app/features/products/add-product/add-product.component';
import { ViewProductComponent } from '@app/features/products/view-product/view-product.component';
import { EditProductComponent } from '@app/features/products/edit-product/edit-product.component';

const routes: Routes = [
  { path: '', component: ProductsComponent },
  { path: 'add', component: AddProductComponent },
  { path: ':productId/edit', component: EditProductComponent },
  { path: ':productId', component: ViewProductComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }
